import LoadingPanel from 'components/loadingPanel/LoadingPanel';
import useYardCheckDetail from 'features/yardCheck/hook/useYardCheckDetail';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { YARD_CHECK_STATUS } from 'utils/constants';
import CheckingContent from './CheckingContent';
import OpenContent from './OpenContent';

const HelpDialogDetail = () => {
    const { id: yardCheckId } = useParams();
    const { yardCheckInfo, selectedLocationId, fetchYardCheckDetailByLocation } = useYardCheckDetail(yardCheckId);

    useEffect(() => {
        if (selectedLocationId) {
            fetchYardCheckDetailByLocation();
        }
    }, [fetchYardCheckDetailByLocation, selectedLocationId]);

    return (
        <>
            {!yardCheckInfo && <LoadingPanel visible={false} />}
            {yardCheckInfo?.status === YARD_CHECK_STATUS.OPEN ? <OpenContent /> : <CheckingContent />}
        </>
    );
};

export default HelpDialogDetail;
